module.exports = __webpack_public_path__ + "static/media/partner2.1e0f9f32.png";